import { render } from "./CircleProgressbar.vue?vue&type=template&id=bffb4018&scoped=true"
import script from "./CircleProgressbar.vue?vue&type=script&lang=js"
export * from "./CircleProgressbar.vue?vue&type=script&lang=js"

import "./CircleProgressbar.vue?vue&type=style&index=0&id=bffb4018&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffb4018"]])

export default __exports__